import { newToolFilterOAuthMcp } from "../oauth.ts";

export const metaAdsPipeboardMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://pipeboard.co/favicon/apple-touch-icon.png",
  url: "https://mcp.pipeboard.co/meta-ads-mcp",
  label: "Meta Ads by Pipeboard",
});
